import { Button, Space, Typography } from 'antd'
import * as React from 'react'
import {
    Container as RSContainer,
    Draggable as RSDraggable
} from '@richardrout/react-smooth-dnd'

import { ItemProps, ItemType } from '../dtos'
import * as styles from './Item.module.less'

const { Text, Title } = Typography

export const ItemDraggableContainer: React.FC<ItemProps> = (props) => {
    const { classNameItem, events, id, isVisible: isFilteredOut } = props
    // const getStyle = (style: React.CSSProperties, snapshot: DraggableStateSnapshot) => {
    // 	if (!snapshot.isDropAnimating) {
    // 		return style
    // 	}
    // 	const { moveTo, curve, duration } = snapshot.dropAnimation
    // 	// move to the right spot
    // 	const translate = `translate(${moveTo.x}px, ${moveTo.y}px)`
    // 	// add a bit of turn for fun
    // 	const rotate = 'rotate(0.5turn)'

    // 	// patching the existing style
    // 	return {
    // 		...style,
    // 		// transform: `${translate} ${rotate}`,
    // 		// slowing down the drop because we can
    // 		transition: 'all 0.1s'
    // 	}
    // }

    const Item = props.Item || DefaultItem

    return (
        <RSDraggable>
            <ItemContainer
                // @ts-ignore
                id={id}
                classNameItem={classNameItem}
                // @ts-ignore
                isVisible={isFilteredOut}
                events={events}
                Item={Item}
                isDragging={false}
                {...props}
            />
        </RSDraggable>
    )
}

export interface ItemContainer extends ItemProps {
    isDragging: boolean
}

export const ItemContainer: React.FC<ItemContainer> = (props) => {
    const { classNameItem, events, id, isDragging, isVisible } = props

    const { events: useless2, Item: useless3, ...data } = props

    const onClick = () => {
        events?.onItemClick && events?.onItemClick(id)
    }

    const onDeleteItemClick = () => {
        events?.onItemDelete && events?.onItemDelete(id)
    }

    const Item = props.Item || DefaultItem
    const className = `${
        isVisible ? styles.item : styles.itemFilteredOut
    } ${classNameItem}`

    const itemProps: ItemProps = {
        ...props,
        data
    }

    return (
        <div
            className={
                isDragging ? `${styles.dragging} ${className}` : className
            }
            onClick={onClick}
        >
            <Item {...itemProps} isDragging={isDragging}>
                <Button onClick={onDeleteItemClick}>Delete</Button>
            </Item>
        </div>
    )
}

const itemPropsAreEqual = (
    prevProps: Readonly<React.PropsWithChildren<ItemType>>,
    nextProps: Readonly<React.PropsWithChildren<ItemType>>
) => {
    // These props don't need to be compared
    const strippedDown = {
        children: undefined,
        events: undefined,
        id: undefined,
        index: undefined,
        isDragging: undefined
    }
    // Strips down objects to props that matter, and compare if needs rendering
    const newPrevProps = Object.assign({}, prevProps, strippedDown)
    const newNextProps = Object.assign({}, nextProps, strippedDown)

    return JSON.stringify(newPrevProps) === JSON.stringify(newNextProps)
}

export const DefaultItem: React.FC<ItemType> = React.memo((props) => {
    return <React.Fragment>{props.children}</React.Fragment>
}, itemPropsAreEqual)

export const DefaultItemWithRenderWatcher: React.FC<ItemType> = React.memo(
    (props) => {
        const { data } = props
        const rerenderRandomNumber = parseInt(
            Math.random().toString(8).substr(2, 2),
            10
        )
        return (
            <DefaultItem {...props}>
                <div style={{ padding: '12px' }}>
                    <div
                        style={{
                            alignItems: 'baseline',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Title level={3}>{data?.title}</Title>
                        <div
                            style={{
                                fontSize: '1.2rem',
                                fontWeight: 'bold',
                                color: 'red'
                            }}
                        >
                            {data?.index}
                        </div>
                        <Title level={4} type="secondary">
                            {data?.owner}
                        </Title>
                    </div>
                    <div
                        style={{
                            alignItems: 'baseline',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}
                    >
                        {props.children}
                        <Text type="secondary">{rerenderRandomNumber}</Text>
                    </div>
                </div>
            </DefaultItem>
        )
    },
    itemPropsAreEqual
)
